import { ChakraV3, Dot, FancyDate } from '@piccolohealth/ui';
import React from 'react';
import { FaTrash } from 'react-icons/fa';
import type { UseTimeseriesChartReturn } from '../../../participantData/hooks/useTimeseriesChart';
import { PhaseChangeLineEditControl } from './PhaseChangeLineEditControl';

interface Props {
  chart: UseTimeseriesChartReturn;
}

export const PhaseChangeList = (props: Props) => {
  const { chart } = props;

  return (
    <ChakraV3.Stack w='full'>
      {chart.widget.phaseChangeLines.map((phaseChangeLine) => (
        <ChakraV3.HStack
          key={phaseChangeLine.id}
          w='full'
          gap={4}
          bg='gray.50'
          rounded='lg'
          py={2}
          px={3}
        >
          <Dot bg={phaseChangeLine.color} size='12px' />
          <ChakraV3.Stack gap={0}>
            <ChakraV3.Text fontWeight='semibold' fontSize='sm'>
              {phaseChangeLine.name}
            </ChakraV3.Text>
            <ChakraV3.HStack>
              <ChakraV3.Text fontSize='xs'>{phaseChangeLine.type}</ChakraV3.Text>
              <FancyDate date={phaseChangeLine.timestamp} showHumanized={false} fontSize='xs' />
            </ChakraV3.HStack>
          </ChakraV3.Stack>
          <ChakraV3.Spacer />
          <ChakraV3.HStack gap={0}>
            <PhaseChangeLineEditControl chart={chart} phaseChangeLine={phaseChangeLine} />
            <ChakraV3.IconButton
              onClick={() => chart.onRemovePhaseChangeLine(phaseChangeLine.id)}
              aria-label='Remove'
              size='2xs'
              variant='ghost'
            >
              <FaTrash />
            </ChakraV3.IconButton>
          </ChakraV3.HStack>
        </ChakraV3.HStack>
      ))}
    </ChakraV3.Stack>
  );
};
